import { ELocalizationLanguage } from "@nitra/nkmb-card-components/utils";
export var ECompetitionType;
(function (ECompetitionType) {
    ECompetitionType["FIRST_LEAGUE"] = "FIRST_LEAGUE";
    ECompetitionType["CUP"] = "CUP";
    ECompetitionType["FRIENDLY"] = "FRIENDLY";
    ECompetitionType["CHAMPIONS_LEAGUE"] = "CHAMPIONS_LEAGUE";
    ECompetitionType["EUROPA_LEAGUE"] = "EUROPA_LEAGUE";
    ECompetitionType["CONFERENCE_LEAGUE"] = "CONFERENCE_LEAGUE";
    ECompetitionType["SUPER_CUP"] = "SUPER_CUP";
    ECompetitionType["CUP_OF_CUP_WINNERS"] = "CUP_OF_CUP_WINNERS";
    ECompetitionType["INTERTOTO"] = "INTERTOTO";
    ECompetitionType["UEFA_CUP"] = "UEFA_CUP";
    ECompetitionType["ANY_UEFA"] = "ANY_UEFA";
})(ECompetitionType || (ECompetitionType = {}));
export function isEuroCompetitionType(competitionType) {
    return competitionType === ECompetitionType.CHAMPIONS_LEAGUE
        || competitionType === ECompetitionType.EUROPA_LEAGUE
        || competitionType === ECompetitionType.CONFERENCE_LEAGUE
        || competitionType === ECompetitionType.INTERTOTO
        || competitionType === ECompetitionType.CUP_OF_CUP_WINNERS
        || competitionType === ECompetitionType.UEFA_CUP
        || competitionType === ECompetitionType.ANY_UEFA;
}
export var getCompetitionNameFromType = function (type, lang) {
    switch (type) {
        case ECompetitionType.CUP:
            return lang === ELocalizationLanguage.EN ? "Slovenian Cup" : "Pokal Slovenije";
        case ECompetitionType.FRIENDLY:
            return lang === ELocalizationLanguage.EN ? "Friendly match" : "Pripravljalna tekma";
        case ECompetitionType.CHAMPIONS_LEAGUE:
            return "UEFA Champions League";
        case ECompetitionType.EUROPA_LEAGUE:
            return "UEFA Europa League";
        case ECompetitionType.CONFERENCE_LEAGUE:
            return "UEFA Conference League";
        case ECompetitionType.INTERTOTO:
            return "UEFA Intertoto Cup";
        case ECompetitionType.CUP_OF_CUP_WINNERS:
            return "UEFA Cup Winners' Cup";
        case ECompetitionType.UEFA_CUP:
            return "UEFA Cup";
        case ECompetitionType.FIRST_LEAGUE:
            return "Prva liga Telemach";
        case ECompetitionType.SUPER_CUP:
            return "Superpokal Slovenije";
        case ECompetitionType.ANY_UEFA:
            return "UEFA";
    }
};
